import IsIterable from '../IsIterable';
import getFinanceNameFromKey from './GetFinanceNameFromKey';
// import getActualKeyFromKey from './GetActualKeyFromKey';
// import { financeNames } from '../../../modules/json/financeNames';

export default class {
    constructor() {
        this.vehicle = false;
        this.Products = false;
    }

    setVehicle(vehicle) {
        this.vehicle = vehicle;
    }

    setProducts(products) {
        this.Products = products;
    }

    getFinanceNameFromProduct(product) {
        // if (product.Key == 'PCP_PAYMENTSEARCH') {
        //     if (product.Product.Name == 'Passport') {
        //         return getFinanceNameFromKey(this.vehicle, 'PSA_PCP_ONLY', true);
        //     }
        //     if (product.Product.Name == 'Peugeot Passport (APR)') {
        //         return getFinanceNameFromKey(this.vehicle, 'PSA_PCP_ONLY', true);
        //     }
        //     if (product.Product.Name == 'Elect 3' || product.Product.Name == 'Citroen Personal Contract Purchase' || product.Product.Name == 'DS Personal Contract Purchase') {
        //         return getFinanceNameFromKey(this.vehicle, 'PSA_PCP_ONLY', true);
        //     }

        //     return getFinanceNameFromKey(this.vehicle, 'DSG_PCP_ONLY', true);
        // }
        return getFinanceNameFromKey(this.vehicle, product.Key, true);
    }

    getQuoteOfKey(key) {
        if (!IsIterable(this.Products)) {
            return false;
        }
        for (let i = 0, len = this.Products.length; i < len; i += 1) {
            if (!this.Products[i].HasError && this.Products[i].Key == key) {
                return this.Products[i];
            }
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/used-vue/api/finance/FinanceProducts.js